import getMailItemByImmutableId from './getMailItemByImmutableId';
import getMailItemByItemId from './getMailItemByItemId';

export default async function getMailItemByImmutableIdOrItemId(
    restImmutableId?: string,
    itemId?: string
) {
    if (restImmutableId) {
        return getMailItemByImmutableId(restImmutableId);
    }

    if (itemId) {
        return getMailItemByItemId(itemId);
    }

    return null;
}
